import React from 'react';

import Hero from './Hero';
import HomeMetricGenerator from './home_components/HomeMetricGenerator';
import HomeCustomSolutions from './home_components/HomeCustomSolutions';
import HomeAboutFramSys from './home_components/HomeAboutFramSys.js';
import "../styles/home.css"

const Home = () => {
  return (
    <div>
      <div>
<Hero />
      </div>
    <div className="home">
      
      <HomeAboutFramSys/>

      <HomeMetricGenerator />
      <HomeCustomSolutions />
    </div>

    </div>
  );
};

export default Home;